/**
 * SectionHeader Component
 *
 * Reusable section header with title and divider for form field groups.
 * Groups related fields under labeled sections in onboarding and settings forms.
 */

import React from "react";
import { cn } from "../utils/cn";

export interface SectionHeaderProps {
  /** Section title text (displayed as uppercase label) */
  title: string;
  /** Unique section identifier for the id attribute */
  sectionId: string;
  /** Optional additional class names */
  className?: string;
}

/**
 * SectionHeader — Form field group header with divider
 *
 * Renders a small uppercase title followed by a horizontal divider line.
 * Used to visually separate groups of related form fields.
 */
export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  sectionId,
  className,
}) => {
  return (
    <div
      className={cn("form-section-header", className)}
      id={`section-${sectionId}`}
    >
      <h3 className="form-section-title">{title}</h3>
      <div className="form-section-divider" />
    </div>
  );
};

export default SectionHeader;
